export default __webpack_public_path__ + "static/media/no-image-available.0255216f.png";